import React from "react";
import { Snackbar, SnackbarContent } from "@material-ui/core";

type SimpleSnackbarProps = {
  // snackbarData: SnackbarData;
  message: string;
  isPositive: boolean;
  showSnackbar: boolean;
  setShowSnackbar: any;
}

function SimpleSnackbar(props: SimpleSnackbarProps){
  const handleClose = (event: React.SyntheticEvent | React.MouseEvent,
    reason?: string) => {
      if (reason === "clickaway") {
      return;
    }
    props.setShowSnackbar(false);
  }
    const color : string = props.isPositive ? "#4caf50" : "#d9211e"
  return (
    <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={props.showSnackbar}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <SnackbarContent
            style={{
              backgroundColor: color,
            }}
            message={<span id="client-snackbar">{props.message}</span>}
          />
        </Snackbar>
  );
};

export default SimpleSnackbar;
